import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';

import { AIOutreachRecipientDropdown } from '../AIOutreachRecipientDropdown';
import { StyledFieldLabel } from '../styles';
import type { Recipient } from '../types';

import { StyledCompanyInput, StyledCompanyInputText, StyledFormSection } from './styles';

type AIOutreachFormProps = {
  domain?: string;
  companyName?: string;
  isPending?: boolean;
  selectedRecipient: Recipient | null;
  onSelectRecipient: (recipient: Recipient | null) => void;
};

export const AIOutreachForm = ({
  domain,
  companyName,
  isPending,
  selectedRecipient,
  onSelectRecipient,
}: AIOutreachFormProps) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledFormSection data-automation="AIOutreachCompanyField">
        <StyledFieldLabel>{t('company.overview.ai-outreach.company', 'Company')}</StyledFieldLabel>
        <StyledCompanyInput>
          <SWReactIcons iconName="company" size="xs" />
          <StyledCompanyInputText type="text" value={companyName ?? domain ?? ''} disabled readOnly />
        </StyledCompanyInput>
      </StyledFormSection>
      <AIOutreachRecipientDropdown
        domain={domain}
        isDisabled={isPending}
        selectedRecipient={selectedRecipient}
        onSelectRecipient={onSelectRecipient}
      />
    </>
  );
};
